"use strict";
// Copyright (c) StrangeBee 2024
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatOptionValue = void 0;
const __1 = require("..");
const utils_1 = require("../../utils");
const formatOptionValue = (value, type) => {
    if (!value) {
        return null;
    }
    if (type === 'integer') {
        return parseInt(value, 10);
    }
    else if (type === 'float') {
        return parseFloat(value);
    }
    return value;
};
exports.formatOptionValue = formatOptionValue;
class CaseController extends __1.ParentController {
    constructor() {
        super(...arguments);
        this.endpoints = {
            create: '/v1/case',
            edit: '/v1/case/:objectId',
            delete: '/v1/case/:objectId',
            merge: '/v1/case/_merge/',
            bulkEdit: '/v1/case/_bulk',
            bulkCaseTemplate: '/v1/case/_bulk/caseTemplate',
            editCustomField: '/case/:objectId',
            deleteCustomField: '/v1/case/customField/:customFieldId',
            addShare: '/v1/case/:caseId/shares',
            bulkEditShare: '/v1/case/:caseId/shares',
            editShare: '/case/share/:shareId',
            deleteShare: '/case/:caseId/shares',
            changeOwner: '/v1/case/:caseId/owner',
            createAttachments: '/v1/case/:objectId/attachments',
            deleteAttachment: '/v1/case/:objectId/attachment/:attachmentId',
            downloadAttachment: '/v1/case/:caseId/attachment/:attachmentId',
            export: '/v1/case/:objectId/export?password=:password',
            import: '/v1/case/import',
            addPage: '/v1/case/:caseId/page',
            editPage: '/v1/case/:caseId/page/:pageId',
            deletePage: '/v1/case/:caseId/page/:pageId',
            createReport: '/v1/case/:caseId/report',
            deleteReport: '/v1/caseReport/:reportId',
            uploadReport: 'v1/case/:caseId/report/upload',
            listReportFormat: '/v1/caseReport/formats',
            renderReport: '/v1/caseReport/render',
        };
    }
    mergeCases(objectId1, objectId2) {
        return this.manager.post({ url: this.endpoints.merge + `${objectId1},${objectId2}` });
    }
    addShare(shares, caseId) {
        return this.manager.post({ url: this.endpoints.addShare, params: { caseId } }, { shares });
    }
    bulkEditShare(shares, caseId) {
        return this.manager.put({ url: this.endpoints.bulkEditShare, params: { caseId } }, { shares });
    }
    changeOwner(options, caseId) {
        return this.manager.post({
            url: this.endpoints.changeOwner,
            params: { caseId },
        }, options);
    }
    bulkCaseTemplate(data, objectIds) {
        (0, utils_1.isRequired)(objectIds);
        return this.manager.post({ url: this.endpoints.bulkCaseTemplate }, Object.assign({ ids: objectIds }, data));
    }
    editShare(profile, shareId) {
        return this.manager.patch({ url: this.endpoints.editShare, params: { shareId } }, { profile });
    }
    deleteShare(organisations, caseId) {
        return this.manager.delete({ url: this.endpoints.deleteShare, params: { caseId } }, { organisations });
    }
    createAttachments(formData, objectId) {
        formData.set('canRename', 'true');
        return this.manager.post({ url: this.endpoints.createAttachments, params: { objectId } }, formData);
    }
    deleteAttachment(attachmentId, objectId) {
        return this.manager.delete({ url: this.endpoints.deleteAttachment, params: { objectId, attachmentId } });
    }
    downloadAttachment(attachmentId, caseId) {
        return this.manager.get({ url: this.endpoints.downloadAttachment, params: { caseId, attachmentId } }, { responseType: 'arraybuffer' });
    }
    getUrlDownloadAttachment(opt) {
        return Object.entries(opt).reduce((url, [key, value]) => url.replace(`:${key}`, value), this.endpoints.downloadAttachment);
    }
    getExportUrl(objectId, password) {
        const passwordEncoded = encodeURIComponent(password);
        return Object.entries({ objectId, password: passwordEncoded }).reduce((url, [key, value]) => url.replace(`:${key}`, value), this.endpoints.export);
    }
    import(formData) {
        return this.manager.post({ url: this.endpoints.import }, formData);
    }
    setCustomField(dataCustomField, objectId) {
        const { name, value, type = 'boolean' } = dataCustomField;
        const fieldsToUpdate = value !== undefined && type
            ? {
                [`customFields.${name}.${type}`]: (0, exports.formatOptionValue)(value, type),
            }
            : {
                [`customFields.${name}`]: { [type]: null, order: null },
            };
        return this.manager.patch({ url: this.endpoints.editCustomField, params: { objectId } }, fieldsToUpdate);
    }
    addPage(page, caseId) {
        return this.manager.post({
            url: this.endpoints.addPage,
            params: { caseId },
        }, page);
    }
    editPage(page, caseId, pageId) {
        return this.manager.patch({
            url: this.endpoints.editPage,
            params: { caseId, pageId },
        }, page);
    }
    deletePage(caseId, pageId) {
        return this.manager.delete({
            url: this.endpoints.deletePage,
            params: { caseId, pageId },
        });
    }
    deleteCustomField(customFieldId) {
        return this.manager.delete({
            url: this.endpoints.deleteCustomField,
            params: { customFieldId },
        });
    }
    createReport(data, caseId) {
        return this.manager.post({ url: this.endpoints.createReport, params: { caseId } }, data);
    }
    deleteReport(reportId) {
        return this.manager.delete({ url: this.endpoints.deleteReport, params: { reportId } });
    }
    uploadReport(data, caseId) {
        return this.manager.post({ url: this.endpoints.uploadReport, params: { caseId } }, data);
    }
    listReportFormat() {
        return this.manager.get({ url: this.endpoints.listReportFormat });
    }
    renderReport(data) {
        return this.manager.post({ url: this.endpoints.renderReport }, data);
    }
}
exports.default = CaseController;
